import { Button } from "@/lib/ui/components/Buttons";
import css from "./AboutDistrictBlock.module.scss";
import { ArrowIcon, SvgPlayTriangle } from "@/lib/ui/icons";
import Link from "next/link";
import { PhuketDistrict, SamuiDistrict } from "@/lib/types/complexPage";
import { useTranslation } from "next-i18next";
import { H1, P3 } from "@/lib/ui/components/Typography";
import cl from "classnames";
import Image from "next/image";
import cn from "classnames";

type AboutDistrictBlockProps = {
  district: PhuketDistrict | SamuiDistrict;
  name: string;
  region: "PHUKET" | "SAMUI";
  blueBgHeader?: boolean;
};

export const AboutDistrictBlock = ({
  district,
  name,
  region,
  blueBgHeader,
}: AboutDistrictBlockProps) => {
  const { t } = useTranslation("index", {keyPrefix: "districtInfo"});
  return (
    <section className={cn(blueBgHeader ? css.blueBgHeader : css.blueBgFooter)}>
      <div className={cl(css.district, css.container)}>
        <div className={css.district_info}>
          <H1 as={'h2'} className={css.district_title}>
            <span>{t("district")}</span>
            <span>{name}</span>
          </H1>
          <div className={css.district_text}>
            <P3>{t(`${district}_1`)}</P3>
            <P3>{t(`${district}_2`)}</P3>
          </div>
        </div>
        {/* пока кнопки не будет */}
        {/* {region !== 'SAMUI' && (
          <div className={css.district_button}>
            <Button
              as={Link}
              href={"/"}
              label={t("moreInfo")}
              theme={blueBgHeader ? "light" : "dark-invert"}
              size={"lg"}
              icon={<ArrowIcon isRight/>}
            />
          </div>
        )} */}
      </div>
      {region !== "SAMUI" && (
        <div className={css.district_image}>
          <div className={css.district_image__wrapper}>
            <Image
              sizes="(min-width: 768px) 80vw, 100vw"
              className={css.district_image__pic}
              src={"/images/complex/region.png"}
              alt=""
              fill
            />
            <div className={css.district_image__button}>
              <Button
                as={Link}
                target="_blank"
                href={"https://www.youtube.com/watch?v=lW9APhnRlHY"}
                label={t(
                  region === "PHUKET"
                    ? "showVideoOfPhuketDistricts"
                    : "showVideoOfSamuiDistricts",
                )}
                theme={"light-invert"}
                size={"md"}
                icon={<SvgPlayTriangle />}
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
